import { FunctionComponent } from 'react';

interface LoadingBarProps {}

const LoadingBar: FunctionComponent<LoadingBarProps> = () => {
  return (
    <div className='w-full h-1 fixed z-[1000] top-0 left-0'>
      <div className='h-full bg-theme-main animate-load-bar w-0'></div>
    </div>
  );
};

export default LoadingBar;
